'use client'

import Markdown from 'markdown-to-jsx'
import React from 'react'
import { rewriteKnownUrlToPublic } from 'roots/(publicContent)/_components/utils/rewriteLinks'

import { OptimizedImage } from '@/legacy-src/components/counselling/ArticleDetail'
import ArticleVideo from '@/legacy-src/components/counselling/ArticleVideo'
import FAQ from '@/legacy-src/components/FAQ'
import Icon from '@/legacy-src/components/icons/Icon'
import { ButtonLink } from '@/legacy-src/components/ui/button'
import AnchorSection from '@/legacy-src/components/university/AnchorSection'

import { ComponentNamesRest } from '../university/componentNames'
import { textToAnchor } from './ArticleAnchors'
import Citation from './Citation'

type Props = { content: any; isPublic?: boolean; isLoggedIn?: boolean; rewriteLinksToPublic?: boolean }

const selectComponent = (componentName, item, isPublic = false, rewriteLinksToPublic = false) => {
  return (
    {
      [ComponentNamesRest.richContent]: item.content && (
        <div className="overflow-x-auto">
          <Markdown
            options={{
              slugify: (str) => textToAnchor(str),
              overrides: { img: { component: OptimizedImage } },
            }}
          >
            {item.content}
          </Markdown>
        </div>
      ),
      [ComponentNamesRest.anchor]: <AnchorSection section={item} />,
      [ComponentNamesRest.buttonLink]: (
        <div className="my-12 flex justify-center">
          <ButtonLink
            variant={item.style === 'primary' ? 'default' : item.style}
            href={rewriteLinksToPublic ? rewriteKnownUrlToPublic(item.link) : item.link}
            className="normal-case"
          >
            {item.text}
            {item.withArrow && <Icon className="ml-6 text-white" icon="arrow" size="sm" />}
          </ButtonLink>
        </div>
      ),
      [ComponentNamesRest.faq]: <FAQ faqs={item} />,
      [ComponentNamesRest.videoContent]: <ArticleVideo item={item} />,
      [ComponentNamesRest.citation]: <Citation citation={item} isPublic={isPublic} />,
    }[componentName] ?? null
  )
}

const ArticleContentIterator: React.FC<Props> = ({ content, isPublic, rewriteLinksToPublic }) => {
  return content?.map((item, key) => {
    return (
      <div
        className={item.__component === ComponentNamesRest.faq ? undefined : 'counselling__content'}
        key={`${item.__component}-${key}`}
      >
        {selectComponent(item.__component, item, isPublic, rewriteLinksToPublic)}
      </div>
    )
  })
}

export default ArticleContentIterator
